import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JwtService } from '../index.service';
import { BehaviorSubject } from 'rxjs';
export interface payment{
  id: number,
  payment_record: {
      status: string,
      bank_type: string,
      tracking_code: string,
      amount: string,
      created_at: string
  },
  additional_data: {}
}

@Injectable({
  providedIn: 'root'
})
export class FinancialService {
  readonly BASE_URL = environment.BASE_API_URL;
  private balancedValueSubject$ = new BehaviorSubject(0)
  public balancedValueObs$ = this.balancedValueSubject$.asObservable()
  constructor(
    private http:HttpClient,
    public jwtService:JwtService
  ) {}
  ngOnInit() {}
  setBalancedValue(balancedValue:any){
    this.balancedValueSubject$.next(balancedValue)
  }
  getBalancedValueObs(){
    return this.balancedValueObs$
  }
  chargeWallet(data:{amount:number,redirect_url:string}){
    return this.http.post<any>(this.BASE_URL+`wallet/pay/`, data)
  }
  getWallet(){
    return this.http.get<any>(this.BASE_URL+`wallet/`)
  }
  getTransactionList(){
    return this.http.get<any>(this.BASE_URL+`wallet/transaction/`)
  }
  getLastPayment(){
    return this.http.get<payment>(this.BASE_URL+'wallet/last_transaction/')
  }
}
